import {DocumentDateKey} from "../types/document-modal.types";

export const documentDateFields: Array<string> = [
  'contract',
  'payment',
  'act'
]

export function isDocumentDateKey(key: string): key is DocumentDateKey {
  return ['contract', 'payment', 'act'].includes(key);
}
